import React, { PropsWithChildren } from 'react';

const logErrorWithBugSnag = (...args: any[]) => {
  console.warn('@TODO', args);
};

interface Props {
  renderError?(): React.ReactNode;
}

export class ErrorBoundary extends React.Component<
  PropsWithChildren<Props>,
  { hasError: boolean }
> {
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  state = { hasError: false };

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    logErrorWithBugSnag(error, errorInfo);
  }

  render() {
    const { renderError = () => null } = this.props;
    if (this.state.hasError) return renderError();
    return this.props.children;
  }
}
